export default __webpack_public_path__ + "media/images/brands/dualit-0370f39d40b2d191d722f8f1168015ce.png";